// Shows why the app could not start, in the #boot-error box of index.html.
export const showBootError = (error, t) => {
  console.error('PleromaFE failed to initialize: ', error)
  const box = document.getElementById('boot-error')
  if (!box) return
  box.querySelector('p').textContent = t('splash.error')
  box.querySelector('code').textContent = String(error)
  box.querySelector('pre').textContent = error?.stack ?? ''
  box.hidden = false
}
